import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DataGrid } from "@mui/x-data-grid";


const columns = [
  { field: 'iu', headerName: 'IU', width: 150, editable: false },
  { field: 'plate', headerName: 'Plate', width: 150, editable: false }
]

export class TerminationReview extends Component {
  constructor(pros) {
    super(pros);
    this.state = {
    };
  }

  render(){

    let startDate = new Date(this.props.startDate);
    let endDate = new Date(this.props.endDate);
    let terminationDate = new Date(this.props.terminationDate);
    let terminationReason = this.props.terminationReason.label;

    let refundAmount = this.props.refundAmount;
    let name = this.props.name;
    let email = this.props.email;
    let companyName = this.props.companyName;
    let phone = this.props.phone;
    let payeeName=this.props.payeeName;
    let rows = this.props.records;
    let remark=this.props.remark;

    let nameLength = this.props.name.length;
    let encryptName = this.props.name.length > 4
        ? this.props.name.substring(0, 2) + "******" + this.props.name.substring(nameLength - 2, nameLength)
        : this.props.name.substring(0, 1) + "******";
    
    let phoneLength = this.props.phone.length;
    let encryptPhone = this.props.phone.substring(0, 2) + "****" + this.props.phone.substring(phoneLength-2, phoneLength);

    let encryptEmails = "";
    let splittedEmails = this.props.email.split(",");
    splittedEmails.forEach((email) => {
      let emailSplit = email.split("@");
      if(encryptEmails){
        encryptEmails += ",";
      }
      encryptEmails += emailSplit[0].substring(0, 2) + "******@******" + emailSplit[1].substring(emailSplit[1].length-2, emailSplit[1].length);
    })
    return (
      <React.Fragment>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              required
              disabled="true"
              id="outlined-required"
              label="Building"
              defaultValue=""
              value={this.props.building}
            />
          </Grid>
          

          <Grid item xs={12}>
            <TextField
                disabled
                id="TerminationReason"
                name="TerminationReason"
                label="TerminationReason*"
                fullWidth
                autoComplete="shipping address-line2"
                value={terminationReason}>
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                disabled
                label="Termination Month*"
                views={['year', 'month']}
                value={terminationDate}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12}>
            <TextField
              disabled
              id="refundAmount"
              name="refundAmount"
              label="Refund Amount"
              fullWidth
              autoComplete="shipping address-line2"
              value={refundAmount}
            />
          </Grid>

          <Grid item xs={12}>
            <div style={{ height: '10%', width: '100%' }}>
              <DataGrid rows={rows} 
                        columns={columns}
                        hideFooter='true' 
                        autoHeight='true'
                        getRowId={(r) => r.iu} />
            </div>
          </Grid>

          <Grid item xs={12}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                disabled
                label="Start Month*"
                views={['year', 'month']}
                value={startDate}
                onChange={(newvalue) => {
                  this.setState({ startDate: newvalue });
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                disabled
                label="End Month*"
                value={endDate}
                views={['year', 'month']}
                onChange={(newvalue) => {
                  this.setState({ endDate: newvalue });
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12}>
            <TextField
              disabled
              id="name"
              name="name"
              label="Name*"
              fullWidth
              autoComplete="shipping address-line2"
              value={encryptName}
              onChange={(event) => {
                this.setState({ name: event.target.value });
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              disabled
              id="email"
              name="email"
              label="Email*"
              fullWidth
              autoComplete="shipping address-line2"
              value={encryptEmails}
              onChange={(event) => {
                this.setState({ email: event.target.value });
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              disabled
              id="phone"
              name="phone"
              label="Phone*"
              fullWidth
              autoComplete="shipping address-line2"
              value={encryptPhone}
              onChange={(event) => {
                this.setState({ phone: event.target.value });
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              disabled
              id="companyName"
              name="companyName"
              label="Company Name*"
              fullWidth
              autoComplete="shipping address-line2"
              value={companyName}
              onChange={(event) => {
                this.setState({ companyName: event.target.value });
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              disabled
              id="payeeName"
              name="payeeName"
              label="Refund Payee Full Name"
              fullWidth
              autoComplete="shipping address-line2"
              value={payeeName} 
            />
          </Grid>
          {terminationReason==="Other" &&
             <Grid item xs={12}>
             <TextField
               disabled
               id="remark"
               name="remark"
               label="Remark"
               fullWidth
               autoComplete="shipping address-line2"
               value={remark}
             />
           </Grid>
          } 
        </Grid>
      </React.Fragment>
    );
  }
  
}
